import findStep from "../../../screens/bot/stepModules/findStep";
import noConnectionHandler from "../../../utils/noConnectionHandler";
import trackConversacaoStep from "../../../utils/trackConversacaoStep";
import useBotControlStore from "../../../storeModules/useBotControlStore";

export const createButtonHandlers = (
  options,
  activeSlide,
  selectedPlanID,
  isSelectedCard,
  setIsSimulateAgain,
  sliderRef,
  functions,
) => {
  const isSimularNovamenteCard =
    options[activeSlide]?.planoCardType === "simular-novamente";

  const handleSetButtonText = () => {
    if (isSimularNovamenteCard) {
      return "SIMULAR NOVAMENTE";
    }

    if (isSelectedCard || !selectedPlanID) {
      return "CONTINUAR";
    }

    if (!isSelectedCard) {
      return "VER MINHA SELEÇÃO";
    }

    return "CONTINUAR";
  };

  const handleClickButton = async () => {
    if (isSimularNovamenteCard) {
      const { lastRenderedStep } = useBotControlStore.getState();
      trackConversacaoStep({
        stepName: lastRenderedStep.name || "planos_disponiveis",
        userMessage: "SIMULAR NOVAMENTE",
        userOnly: true,
      });

      setIsSimulateAgain(true);
      functions.setCurrentStep(findStep("pergunta_valor_credito").index);

      if (typeof functions.tagNovaSimulacao === "function") {
        functions.tagNovaSimulacao();
      }
      return;
    }

    if (!isSimularNovamenteCard && !isSelectedCard) {
      // Encontrar o índice correto do slide baseado no selectedPlanID
      const targetSlideIndex = options.findIndex((option) =>
        option?.planosTipos?.some((plano) => plano.planoID === selectedPlanID),
      );

      if (targetSlideIndex >= 0 && sliderRef?.current?.slickGoTo) {
        sliderRef.current.slickGoTo(targetSlideIndex);
      }
      return;
    }

    await noConnectionHandler().then(() => {
      functions.handleGetPlanDetails();
    });

    await noConnectionHandler().then(() => {
      if (typeof functions.sendSelectedPlan === "function") {
        functions.sendSelectedPlan();
      }
    });
  };

  const handleSetButtonStyle = () => {
    if (
      options[activeSlide]?.planoCardType !== "simular-novamente" &&
      !isSelectedCard &&
      selectedPlanID !== null
    ) {
      return "outlined";
    }
  };

  const isButtonEnabled = () => {
    return isSimularNovamenteCard || isSelectedCard || !!selectedPlanID;
  };

  return {
    isSimularNovamenteCard,
    handleSetButtonText,
    handleClickButton,
    handleSetButtonStyle,
    isButtonEnabled,
  };
};
